import React, { useContext, useState } from "react";
import { ProductsContext } from "../../../../utils/stateHandlers/contexts";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import _ from "lodash";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default function OuterDiameter(props) {
  const { productState, productDispatch } = useContext(ProductsContext);
  const { validationErrors, priceLoaded } = productState;
  const [localOuterDiameter, setLocalOuterDiameter] = useState(null);
  const field = props.field;

  function selectOuterDiameter(outer_diameter) {
    if (outer_diameter === "None") {
      productDispatch({
        type: "setValidationErrors",
        payload: _.concat(validationErrors, "outer_diameter"),
      });
    } else {
      const remove = _.filter(validationErrors, function (error) {
        return error !== "outer_diameter";
      });
      productDispatch({ type: "setValidationErrors", payload: remove });
    }
    productDispatch({ type: "setClear", payload: false });
    setLocalOuterDiameter(outer_diameter);
    productDispatch({
      type: "updateFields",
      field: "outer_diameter",
      payload: outer_diameter,
    });
  }

  // useEffect(() => {
  //   if (clear) {
  //     productDispatch({ type: "setClear", payload: false });
  //     productDispatch({
  //       type: "setValidationErrors",
  //       payload: _.concat(validationErrors, "outer_diameter"),
  //     });
  //     setLocalOuterDiameter("None");
  //     productDispatch({
  //       type: "updateFields",
  //       field: "outer_diameter",
  //       payload: "None",
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [clear]);

  return (
    <Stack>
      <Typography sx={{ fontWeight: "700", paddingBottom: ".3rem" }}>
        {field.label}
      </Typography>
      <FormControl error={localOuterDiameter === "None" ? true : false}>
        <Select
          value={
            localOuterDiameter === null ? field.default : localOuterDiameter
          }
          size="small"
          sx={{ width: "100%" }}
          disabled={!priceLoaded || (field.values && field.values.length === 1)}
          onChange={(e) => {
            e.target.value !== localOuterDiameter &&
              selectOuterDiameter(e.target.value);
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #939598",
                borderRadius: "0",
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
              },
            },
          }}
        >
          <MenuItem value="None">
            <em>Select...</em>
          </MenuItem>
          {field.values &&
            field.values.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
        </Select>
        <FormHelperText>
          {localOuterDiameter === "None" ? "Please Make A Selection" : ""}
        </FormHelperText>
      </FormControl>
    </Stack>
  );
}
